import { action, computed, observable, runInAction, makeObservable } from "mobx";
import { IParametrosUsuario } from "../modelo/Parametros";
import { TipoEscaninho } from "../modelo/TipoEscaninhoEnum";
import StoreParaSingleton from "./StoreParaSingleton";
import TopBarStore from "./TopBarStore";
import FiltroStore from "./FiltroStore";
import ParametroUsuarioService from "@/services/ParametroUsuarioService";
import MensagemStore from "./MensagemStore";

class ParametroUsuarioStore extends StoreParaSingleton {
    parametros: Array<IParametrosUsuario> = [];
    parametrosFiltro: IParametrosUsuario[] = [];
    parametrosColuna: IParametrosUsuario[] = [];
    parametrosIcone: IParametrosUsuario[] = [];
    sigla: string = "";
    siglaSalva: string | null = null;
    exibirDialogSigla: boolean = false;

    constructor() {
        // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
        super();

        makeObservable(this, {
            parametros: observable,
            parametrosFiltro: observable,
            parametrosColuna: observable,
            parametrosIcone: observable,
            sigla: observable,
            siglaSalva: observable,
            exibirDialogSigla: observable,
            parametrosColunaArray: computed,
            parametrosFiltroArray: computed,
            parametrosIconeArray: computed,
            colunas: computed,
            filtros: computed,
            icones: computed,
            setSigla: action,
            limparSigla: action,
            salvarSigla: action,
            siglaAtual: computed
        });
    }

    get parametrosColunaArray() {
        return Object.values(this.parametrosColuna || {});
    }

    get parametrosFiltroArray() {
        return Object.values(this.parametrosFiltro || {});
    }

    get parametrosIconeArray() {
        return Object.values(this.parametrosIcone || {});
    }

    get colunas() {

        return Object.values(this.parametrosColuna);
    }

    get filtros() {
        return Object.values(this.parametrosFiltro);
    }

    get icones() {
        return Object.values(this.parametrosIcone);
    }

    setSigla(sigla: string) {

        let filtrada = sigla.replace(/[^A-Za-z0-9_/-]/g, "");

        filtrada = filtrada.slice(0, 40);

        const primeirosDois = filtrada.slice(0, 2);
        if (/^[/_-]{2}$/.test(primeirosDois)) {
            filtrada = "";
        }

        this.sigla = filtrada;
    }

    limparSigla() {
        this.sigla = "";
    }

    async salvarSigla() {
        try {
            await ParametroUsuarioService.salvarSigla(this.sigla);

            runInAction(() => {
                this.siglaSalva = this.sigla;
                this.sigla = "";
            });

            MensagemStore.apresentarMensagem("Sigla salva com sucesso!");
        } catch (error) {
            console.error("Erro ao salvar sigla: ", error);
            MensagemStore.apresentarErro(`Erro ao salvar sigla. ${error}`);
        }
    }

    get siglaAtual() {
        return this.siglaSalva
    }

    converteTitulo(titulo: string) {
        switch (titulo) {
            case 'Escaninho do Gabinete':
                return TipoEscaninho.GERENCIAL.id

            case 'Escaninho do Usuário':
                return TipoEscaninho.USUARIO.id

            default:
                break;
        }
    }

    mostraColuna = (coluna: string): boolean => {
        const parametro = this.parametrosColuna[coluna + this.converteTitulo(TopBarStore.titulo)]
        return parametro ? parametro.valor === 'true' : true;
    }


    mostraFiltro = (filtro: string, isEscaninhoPeticao = false): boolean => {
        const filtroSelecionadoNaBuscaDeFiltros = FiltroStore.filtrosFilter.find(filt => filt.toString() === filtro) || FiltroStore.filtrosFilter.length === 0;
        const parametro = this.parametrosFiltro[filtro + this.converteTitulo(TopBarStore.titulo)]
        const condicaoParametro = parametro ? parametro.valor === 'true' || isEscaninhoPeticao : true;

        return condicaoParametro && !!filtroSelecionadoNaBuscaDeFiltros;
    };


    mostraIcone = (icone: string) => {
        const retorno = this.parametrosIcone[icone + this.converteTitulo(TopBarStore.titulo)]
        return retorno ? retorno.valor === 'true' : true;
    }
}

export default new ParametroUsuarioStore();